import { Component, inject, Input } from '@angular/core';
import { ModalWizardModels } from 'src/app/components/modal-wizard/shared/models/modal-wizard.model';
import { BidResultComponent } from '../../components/bid-result/bid-result.component';
import { BiddingModels } from '../../shared/models/bidding.model';
import { BiddingStoreKey, BiddingStoreService } from '../../store/bidding.store';

@Component({
  selector: 'app-bid-result-step-content',
  template: `
    <div class="bid-result-step-content">
      <app-bid-result />
    </div>
  `,

  imports: [BidResultComponent],
})
export class BidResultStepContentComponent implements ModalWizardModels.StepContent {
  private biddingStoreService = inject(BiddingStoreService);

  @Input() stepId = 'bid-result-step';

  biddingResult = BiddingModels.BiddingResult;
  result$ = this.biddingStoreService.getSelector(BiddingStoreKey.bidResult);

  canEntry(args: ModalWizardModels.StepValidationArgs) {
    return true;
  }

  canExit(args: ModalWizardModels.StepValidationArgs) {
    return true;
  }
}
